<template>
    <div>
        {{ fullUrlPreviewDescription }}
    </div>
    <div class="text-wrap text-break">
        {{ fullUrlPreview }}
    </div>
</template>

<script setup>
    import { computed } from "vue";
    import { useResource } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/previewWebAdapterUrl.i18n";

    const props = defineProps({
        isProdPreview: {
            type: Boolean,
            required: false,
            default: false
        },
        baseUri: {
            type: String,
            required: false,
            default: null
        },
        relativeUri: {
            type: String,
            required: false,
            default: null
        }
    });

    const { fullProductionUrlDescription, fullTestUrlDescription } = useResource(KEYS, NAMESPACE);

    const fullUrlPreviewDescription = computed(() => {
        return props.isProdPreview ? fullProductionUrlDescription.value : fullTestUrlDescription.value;
    });

    const fullUrlPreview = computed(() => {
        const trimmedRelativeUri = props.relativeUri?.trim();
        if (!trimmedRelativeUri) {
            return props.baseUri;
        }

        const trailingForwardSlashRegex = /\/$/;
        const leadingForwardSlashRegex = /^\//;

        // Remove at most one trailing slash from the base URL to avoid unintentional double slashes
        const formattedBaseUri = props.baseUri.replace(trailingForwardSlashRegex, "");

        // Add at most one leading slash to the relative URI to ensure there is always a separating slash
        const formattedRelativeUri = leadingForwardSlashRegex.test(trimmedRelativeUri)
            ? trimmedRelativeUri
            : "/" + trimmedRelativeUri;

        return formattedBaseUri + formattedRelativeUri;
    });
</script>
